import { render, staticRenderFns } from "./CoursePass.vue?vue&type=template&id=19154336"
import script from "./CoursePass.vue?vue&type=script&lang=js"
export * from "./CoursePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports